import { Label as LabelPrimitive } from 'radix-ui'
import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
    return (
        <LabelPrimitive.Root
            data-slot="label"
            className={cn(
                'flex select-none items-center gap-1.5 text-xs font-medium leading-none text-foreground',
                'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
                'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
                className
            )}
            {...props}
        />
    )
}

export { Label }
